import {
	TagType,
	DocumentTags
} from 'phoenix/domain';
import SettingsService from 'phoenix/services/settingsService';
import { OneOrMany } from 'util/domain/standard-types';

/**
* @ngdoc service
* @name  sharebase.sbTagService
* 
* @description 
* A service used to retrieve and interact with ShareBase tags
**/
export class TagService {
	public static $inject = [
		'$http',
		'settingsService'
	];

	constructor(
		private $http:ng.IHttpService,
		private settingsService:SettingsService
	) {
	}

	/**
	* @ngdoc method
	* @name sbTagService#getTagTypes
	* @methodOf sharebase.sbTagService
	* @kind function
	*
	* @description
	* Gets all tags specific to a user
	*
	* @returns {Deferred} A promise that will resolve with a user's tag types
	* 
	*/
	public getTagTypes() {
		return this.$http.get<TagType[]>(this.settingsService.serverAPIPath + '/tagtypes')
			.then(response => response.data);
	}

	/**
	* @ngdoc method
	* @name sbTagService#getTags
	* @methodOf sharebase.sbTagService
	* @kind function
	*
	* @description
	* Gets all tags specific to a user or system
	* 
	* @param {object} tagType A Tag Type
	*
	* @returns {Deferred} A promise that will resolve with a collection of (user or system) tags
	* 
	*/
	public getTags(tagType:TagType) {
		return this.$http.get<string[]>(tagType.Links.TagValuesUri)
			.then(response => response.data);
	}

	/**
	* @ngdoc method
	* @name sbTagService#getDocumentTags
	* @methodOf sharebase.sbTagService
	* @kind function
	*
	* @description
	* Gets a document's tags
	* 
	* @param {object} documentId A Document ID
	*
	* @returns {Deferred} A promise that will resolve with a document's tags
	* 
	*/
	public getDocumentTags(documentId:number) {
		return this.$http.get<DocumentTags>(this.settingsService.serverAPIPath + '/documents/' + documentId + '/tags')
			.then(response => response.data);
	}

	/**
	* @ngdoc method
	* @name sbTagService#setDocumentTags
	* @methodOf sharebase.sbTagService
	* @kind function
	*
	* @description
	* Sets the document's tags
	* 
	* @param {object} documentId A Document ID
	* 
	* @param {object} tags An object of updated document tags
	* 
	*/
	public setDocumentTags(tags:DocumentTags) {
		return this.$http.post(tags.Links.CreateUri, tags);
	}

	/**
	* @ngdoc method
	* @name sbDocumentDetailService#removeDocumentTag
	* @methodOf sharebase.sbTagService
	* @kind function
	*
	* @description
	* removes document tags
	* 
	* @param {object} documentId A Document ID
	* 
	* @param {array} tags An array of the documents tags to remove
	* 
	*/
	public removeDocumentTag(documentId:number, tag:OneOrMany<string>) {
		let tags = [];
		if (Array.isArray(tag)) {
			tags = tag;
		}
		else {
			tags.push(tag);
		}
		let deleteTags = { AnonymousTags: tags };
		return this.$http.post(this.settingsService.serverAPIPath + '/documents/' + documentId + '/tags?remove=true', deleteTags)
			.then(results => results.data);
	}
}



// WEBPACK FOOTER //
// ./src/sharebase/services/tagService.ts